import { type InstagramLinksCMS } from "@repo/common/src/types/firestore/cms/instagramLinks";
import { CMSCollections } from "@repo/common/src/types/firestore/collections";
import { buildCollection, buildEntityCallbacks, buildProperty, type EntityOnSaveProps } from "@firecms/core";

import { Groups } from "./types";
import { standardPermissions } from "../utils/constants";
import { loadingOverlay } from "../utils/loadOverlay";

const callbacks = buildEntityCallbacks({
  onPreSave: async (props: EntityOnSaveProps<InstagramLinksCMS>) => {
    loadingOverlay.show();
    const { values } = props;
    return values;
  },
  onSaveSuccess: async () => {
    loadingOverlay.hide();
  },
  onSaveFailure: async () => {
    loadingOverlay.hide();
  },
});

export const instagramLinks = buildCollection<InstagramLinksCMS>({
  id: CMSCollections.InstagramLinks,
  name: "Instagram Links Website",
  description: "Mehrere Einträge können hinter einem Dokument hinterlegt werden.",
  singularName: "Instagram Link",
  path: CMSCollections.InstagramLinks,
  icon: "Instagram",
  group: Groups.Other,
  subcollections: [],
  permissions: () => {
    return standardPermissions;
  },
  callbacks,
  properties: {
    links: buildProperty({
      dataType: "array",
      name: "Link",
      of: buildProperty({
        dataType: "map",
        name: "Link",
        properties: {
          title: buildProperty({
            dataType: "string",
            name: "Titel",
            validation: {
              required: true,
            },
          }),
          link: buildProperty({
            dataType: "string",
            name: "Text",
            validation: {
              required: true,
            },
          }),
        },
      }),
      description: "Liste von Links",
      validation: {
        required: true,
      },
    }),
    updated_on: buildProperty({
      name: "Aktualisierungsdatum",
      dataType: "date",
      autoValue: "on_update",
    }),
  },
});
